import api from '@/core/api/client';
import type {
  Announcement,
  AnnouncementListResponse,
  AnnouncementStatus,
  CreateAnnouncementInput,
  PublishAnnouncementResult,
  UpdateAnnouncementInput,
} from '../types';

export type AnnouncementsListParams = {
  page?: number;
  limit?: number;
  search?: string;
  status?: AnnouncementStatus;
};

export const announcementsService = {
  async list(params: AnnouncementsListParams = {}): Promise<AnnouncementListResponse> {
    const response = await api.get('/announcements', { params });
    if (response.data.success) {
      return {
        announcements: response.data.announcements,
        total: response.data.total,
        page: response.data.page,
        limit: response.data.limit,
      };
    }
    throw new Error(response.data.message || 'Erro ao listar comunicados');
  },

  async get(id: string): Promise<Announcement> {
    const response = await api.get(`/announcements/${id}`);
    if (response.data.success) return response.data.announcement;
    throw new Error(response.data.message || 'Erro ao carregar comunicado');
  },

  async create(data: CreateAnnouncementInput): Promise<Announcement> {
    const response = await api.post('/announcements', data);
    if (response.data.success) return response.data.announcement;
    throw new Error(response.data.message || 'Erro ao criar comunicado');
  },

  async update(id: string, data: UpdateAnnouncementInput): Promise<Announcement> {
    const response = await api.patch(`/announcements/${id}`, data);
    if (response.data.success) return response.data.announcement;
    throw new Error(response.data.message || 'Erro ao atualizar comunicado');
  },

  async publish(id: string): Promise<PublishAnnouncementResult> {
    const response = await api.post(`/announcements/${id}/publish`);
    if (response.data.success) {
      return {
        announcement: response.data.announcement,
        recipientCount: response.data.recipientCount,
      };
    }
    throw new Error(response.data.message || 'Erro ao publicar comunicado');
  },

  async archive(id: string): Promise<Announcement> {
    const response = await api.post(`/announcements/${id}/archive`);
    if (response.data.success) return response.data.announcement;
    throw new Error(response.data.message || 'Erro ao arquivar comunicado');
  },

  async remove(id: string): Promise<void> {
    const response = await api.delete(`/announcements/${id}`);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Erro ao excluir comunicado');
    }
  },

  async uploadMedia(file: File): Promise<{ url: string }> {
    const fd = new FormData();
    fd.append('file', file);
    const response = await api.post('/announcements/media', fd);
    if (response.data.success && response.data.url) {
      return { url: response.data.url as string };
    }
    throw new Error(response.data.message || 'Erro ao enviar imagem');
  },
};
